import { Component, OnInit, Output, EventEmitter, AfterContentInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  title = 'proyecto';
  public tabs_state;
  public param: any;
  isEN: boolean;

  languaje: string;

  constructor(private route: ActivatedRoute,
    private render: Renderer2,
    private titleService: Title) {
    this.tabs_state = {
      website: false,
      miles_upperclub_program: false,
      miles_upperclub_general: false,
      glosary: true,
      miles_upperclub_benefits: false,
      stay_care: false,
      fly_care: false,
      other: false,
      best: false,
      exclusion: false,
      cyber: false,
      coverage: false,
      service: false,
      privacy: false,
      flex: false
    }
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.param = params['header'];
      let lang: string = params['lang'];
      if (lang) {
        if (lang.toLowerCase() === 'en') {
          this.languaje = 'en';
          sessionStorage.setItem('lang', lang);
          this.titleService.setTitle('Terms and Conditions');
        } else {
          this.languaje = lang;
          sessionStorage.setItem('lang', lang);
          this.titleService.setTitle('Términos y Condiciones');
        }
      }
    });

    let lang = sessionStorage.getItem('lang');
    this.languaje = lang.toLowerCase();
  }

  resetFlags() {
    this.tabs_state = {
      glosary: false,
      website: false,
      miles_upperclub_program: false,
      miles_upperclub_general: false,
      miles_upperclub_benefits: false,
      stay_care: false,
      fly_care: false,
      other: false,
      best: false,
      exclusion: false,
      cyber: false,
      coverage: false,
      service: false,
      privacy: false,
      flex: false
    }
  }

}
